import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { RealtimeRevenueTemplate } from 'components/Templates'

const RealtimeRevenue: FC = () => {
  return (
    <Layout headline={'リアルタイム売上確認'} iconPath={'/icon/white/revenue.svg'} title={'リアルタイム売上確認'}>
      <RealtimeRevenueTemplate />
    </Layout>
  )
}

export default RealtimeRevenue
